import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TThunkAction } from '../../types/redux/thunk';
import { extractJsonQueryAction, mergeJsonQueryAction, setJsonQueryAction } from '../jsonQuery';
import { promosRequestAction } from '../promos';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 * @param partialJsonQuery: IJsonQuery - часть jsonQuery, мерджит с текущим и отправляет запрос
 * @param isActive: boolean - определяет удалить или добавить элемент
 */
export const promosApplyChipsRequestAction =
  (partialJsonQuery: IJsonQuery, isActive: boolean): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = state.jsonQuery;

    try {
      dispatch(mergeJsonQueryAction({ page: null }));

      if (isActive) {
        dispatch(extractJsonQueryAction(partialJsonQuery));
      } else {
        dispatch(mergeJsonQueryAction(partialJsonQuery));
      }

      await dispatch(promosRequestAction());
    } catch (e) {
      dispatch(setJsonQueryAction(jsonQuery));
    }
  };
